
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Das Coronavirus stellt unseren Alltag total auf den Kopf. Wir haben dazu Fragen von Ihnen, liebe Leserinnen und Leser gesammelt, gesichtet und zusammengestellt.`}</p>
    <p>{`Die Frage, die unsere Leserinnen und Leser am Meisten interessiert hat, ist: `}<strong parentName="p">{`«Der Staat wertet mittels Handydaten aus, wo und wie wir uns bewegen. Wie funktioniert das und wie weit darf er gehen?»`}</strong></p>
    <p>{`Die «Bund»-Redaktion recherchiert nun für Sie. Der Artikel dazu erscheint ab dem 18. April.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;